export default "__VITE_ASSET__ByiuC17G__"